import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import refresh from '../../assets/images/refresh.png';
import Navbar from '../../components/navbar/index';
import Footer from '../../components/Footer/Footer';
import TextField from '@mui/material/TextField';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
export default function TopSectors(){
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
    return(
        <>
        <Navbar/>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", margin: "1rem", justifyContent: { xs: "center", sm: "flex-start" } }}>
          <TextField id="outlined-basic" label="Search" variant="outlined" sx={{ width: { xs: "100%", sm: 350, md: 500 } }} />
          <Button variant="contained" sx={{ backgroundColor:"green", mt: { xs: 1, sm: 0 } }} color='success'>Search</Button>
        </Box>
        <Box sx={{ display:"flex", flexWrap:"wrap", margin:"1rem 0rem 3rem 0rem" }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ width: "100%", px: 1 }}>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
            <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
          <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box>
          </Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh1' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh2' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh11' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh12' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} alt='refresh13' style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
        <Grid xs={6} sm={4} md={2} style={{ height: 150, marginTop: "2rem" }}>
          <Item sx={{ display:"flex", justifyContent:"center", '&:hover':{ transform: "scale(1.03)" } }}>
            <Box sx={{ width: "100%", height: 150 }}>
            <img src={refresh} style={{ height:80 }}/>
            <Typography sx={{ '&:hover':{ color:"green", cursor:"pointer" } }}>Agriculture</Typography>
            <p>3</p>
          </Box></Item>
        </Grid>
      </Grid>
      </Box>
      <Footer/>
        </>
    )
}
